import {useCallback} from 'react'
import {useDispatch,useSelector} from "react-redux";
import {updateConfig} from "../../app/action";
export const getAddonConfig = (addons,configurations,cid) => {
    if (addons && Object.keys(addons).length && configurations[cid]) {
        const {billing_cycle_id} = configurations[cid]
        let selectedKeys = Object.keys(addons).filter(item => (addons[item] === true))
        const getSelectedAddons = () => {
            if (selectedKeys && selectedKeys.length > 0) {
                return selectedKeys.map(item => {
                    const id = parseInt(item.replace('addon-', ''))
                    return ({
                        id,
                        billing_cycle_id
                    })
                })
            }
            return []
        }
        return {
            addons: getSelectedAddons()
        }
    }
    return {
        addons: []
    }
}
export const usePageCallback = (cid)=>{
    const {configurations} = useSelector(state=>({
        configurations: state.app.configurations
    }))
    const dispatch = useDispatch()
    const setBillingCycle = useCallback((billingCycleID) => {
        updateConfig(configurations, cid, {
            billing_cycle_id: billingCycleID,
            step: 1
        }, dispatch)
    }, [cid, configurations, dispatch])
    const getAdditionalOptionsData = useCallback(() => {
        if(configurations && configurations[cid] && configurations[cid].selectedProduct && configurations[cid].selectedProduct.attributes){
            const { addons } = configurations[cid].selectedProduct.attributes
            return addons
        }
        return null
    }, [configurations,cid])
    const setAddons = useCallback((addons) => {
        const addonConfig = getAddonConfig(addons,configurations,cid)
        updateConfig(configurations, cid, addonConfig, dispatch)
    }, [dispatch, configurations, cid])
    return ({
        setBillingCycle,
        getAdditionalOptionsData,
        setAddons
    })
}